export const IconArrowDropDown = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconArrowDropDown_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconArrowDropDown_svg__a)">
        <path d="m11.39 15.204-4.216-4.216A.547.547 0 0 1 7 10.581q0-.232.16-.407A.55.55 0 0 1 7.58 10h8.838q.26 0 .421.174.16.175.16.407 0 .06-.174.407l-4.216 4.216a.9.9 0 0 1-.29.203.9.9 0 0 1-.32.058.9.9 0 0 1-.32-.058.9.9 0 0 1-.29-.203" />
      </g>
    </svg>
  );
};
